<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-if="role ==='admin'" v-slot:navbarname>
                <b-link
                        :to="{name:'AddCategory'}"
                        class="btn btn-primary btn-round">
                    + Neue Kategorie
                </b-link>
            </template>
        </navbar>

        <h2>
            <span>Gesamtzahl der Produkte: </span>
            <span class="font-weight-bold">{{productCount}}</span>
        </h2>

        <template v-if="items.length > 0">
            <draggable v-model="items" group="items"
                       @update="updateOrder"
                       handle=".handle"
                       @start="drag=true"
                       @end="drag=false">
                <b-card
                        v-for="(item,index) in items"
                        :key="index"
                        :class="{'border border-danger':item.is_hide === 'yes'}">
                    <b-media left-align vertical-align="center">
                        <template #aside>
                            <b-img :src="item.image_url"
                                   style="object-fit: contain"
                                   height="45"
                                   width="80" alt="placeholder"></b-img>
                        </template>
                        <h5 class="mt-0 mb-1 font-weight-bold">{{item.title}}</h5>
                        <p class="mb-0">
                            <b-link
                                    :to="{name:'ShowCategory',params:{'categoryid':item.id}}"
                                    class="mr-4">
                                <span class="material-icons font-14">create</span>
                                <span>edit</span>
                            </b-link>
                            <b-link
                                    :to="{name:'ProductsList',params:{'categoryid':item.id}}"
                                    class="mr-4">products
                            </b-link>
                            <b-link
                                    :to="{name:'SubCategory',params:{'categoryid':item.id}}"
                                    class="mr-4">sub categories
                                <span>({{item.subCategories}})</span>
                            </b-link>
                          <b-link
                                    :to="{name:'CategoryCountries',params:{'categoryid':item.id}}"
                                    class="mr-4">
                            countries
                            </b-link>
                            <b-link
                                    v-if="role ==='admin'"
                                    class="text-danger" @click.prevent="deleteCategory(item.id)">delete</b-link>

                        </p>
                        <p class="mb-0 mt-3">
                            <span class="mr-2">Anzahl der Produkte:</span>
                            <span class="font-weight-bold">{{item.products}}</span>
                        </p>

                        <div class="text-right">
                            <span class="mr-3 handle">
                                <span class="material-icons">drag_handle</span>
                            </span>
                        </div>
                    </b-media>
                </b-card>
            </draggable>

        </template>


    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notification from '../../Services/Notification/Nottification'
    import draggable from 'vuedraggable'


    export default {
        name: "Index",
        components: {
            Navbar,
            draggable
        },
        data() {
            return {
                items: [],
                role: null,
                productCount: 0
            }
        },
        methods: {
            deleteCategory(id) {
                if (confirm(this.$t('alertText'))) {
                    this.$Progress.start();
                    Http.get(Http.apiurlV2() + 'category/delete/' + id)
                        .then(response => {
                            this.$Progress.finish();
                            if (response.data.status_code === Http.ok()) {
                                this.getCategories();
                                Notification.success(response.data.message)
                            } else {
                                Notification.error(response.data.message)

                            }
                        })
                        .catch(error => {
                            this.$Progress.finish();
                        })
                }

            },
            getCategories() {
                this.$Progress.start();
                Http.get(Http.apiurlV2() + 'category/index')
                    .then(response => {
                        if (response.data.status_code === Http.ok()) {
                            this.$Progress.finish();
                            this.productCount = response.data.data.productCount;
                            this.items = response.data.data.items;
                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
            updateOrder() {
                this.$Progress.start();
                Http.post(Http.apiurlV2() + 'category/update/order/items', {
                    items: this.items
                })
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.ok()) {
                            this.getCategories();
                            Notification.success(response.data.message)
                        } else {
                            Notification.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })
            },
        },
        created() {
            this.getCategories();
        },
        mounted() {
            this.role = localStorage.getItem('role');
        }
    }
</script>

<style scoped>

</style>